import {
  useDisclosure,
  Menu,
  MenuButton,
  IconButton,
  Portal,
  MenuList,
  MenuItem,
  MenuDivider,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Icons, defaultIconSize } from '../../Icons';
import { sampleEvents } from '../events';
import {
  SampleNextActionProps,
  GeneralSamplesMenuActions,
  useGeneralSampleModals,
} from '../SampleNextAction';
import { SetSamplesAsReceivedFromSupplierModal } from '../SetSamplesAsReceivedFromSupplierModal';
import { usePortalRefValue } from '@texas/hooks/usePortalRef';
import { SetSamplesReadyDateModal } from '../SetSamplesReadyDateModal';

export function MarkReceivedFromSupplier(props: SampleNextActionProps) {
  const markReceivedDisclosure = useDisclosure();
  const setReadyDateDisclosure = useDisclosure();
  const { t } = useTranslation();

  const { ref } = usePortalRefValue();

  const {
    setLostOnOpen,
    updateOwnerOnOpen,
    rejectOnOpen,
    stopFollowOnOpen,
    modals,
  } = useGeneralSampleModals();

  if (!props.sampleId) {
    return null;
  }

  return (
    <>
      <Menu isLazy={true}>
        <MenuButton
          as={IconButton}
          size="sm"
          variant="ghost"
          aria-label={t('sample.menu')}
          icon={<Icons.DotsHorizontal boxSize={defaultIconSize} />}
        />
        <Portal containerRef={ref}>
          <MenuList zIndex={10}>
            <MenuItem
              onClick={markReceivedDisclosure.onOpen}
              icon={<Icons.GiftOpen boxSize={defaultIconSize} />}
            >
              {t('sample.markReceivedFromSupplier')}
            </MenuItem>
            <MenuItem
              icon={<Icons.CalendarCheck boxSize={defaultIconSize} />}
              onClick={setReadyDateDisclosure.onOpen}
            >
              {t('sample.editReadyDate')}
            </MenuItem>
            <MenuDivider />
            <GeneralSamplesMenuActions
              pas={[props.pa!]}
              sampleIds={[props.sampleId]}
              rejectOnOpen={rejectOnOpen}
              setLostOnOpen={setLostOnOpen}
              updateOwnerOnOpen={updateOwnerOnOpen}
              stopFollowOnOpen={
                props.hideStopFollowing ? null : stopFollowOnOpen
              }
            />
          </MenuList>
        </Portal>
      </Menu>

      {modals}
      <SetSamplesAsReceivedFromSupplierModal
        isOpen={markReceivedDisclosure.isOpen}
        onClose={markReceivedDisclosure.onClose}
        sampleIds={[props.sampleId]}
        onReceived={() => sampleEvents.onSampleReceivedFromSupplier.dispatch()}
      />
      <SetSamplesReadyDateModal
        isOpen={setReadyDateDisclosure.isOpen}
        onClose={setReadyDateDisclosure.onClose}
        sampleIds={[props.sampleId]}
        onPerformed={() => sampleEvents.onSampleReadyDateUpdated.dispatch()}
      />
    </>
  );
}
